import { all } from "@awesome.me/kit-c3fa1e0dcc/icons";
// FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { createInertiaApp } from "@inertiajs/vue3";
import * as Sentry from "@sentry/vue";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createApp, h } from "vue";

import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import "../css/app.css";
import "./bootstrap";

library.add(...all);

const appName = import.meta.env.VITE_APP_NAME || "Qualta";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        // Only initialize Sentry in production
        if (import.meta.env.VITE_SENTRY_DSN_PUBLIC && import.meta.env.PROD) {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
                environment: "production",
                ignoreErrors: ["Non-Error promise rejection captured"],
                // Performance monitoring
                tracesSampleRate: 0.1, // 10% of transactions
            });
        }

        app.use(plugin)
            .use(ZiggyVue)
            .component("faIcon", FontAwesomeIcon)
            .mount(el);

        return app;
    },
    progress: {
        color: "#4B5563",
    },
});
